import { render, staticRenderFns } from "./McmButton.vue?vue&type=template&id=95d557c2&scoped=true"
import script from "./McmButton.vue?vue&type=script&lang=ts"
export * from "./McmButton.vue?vue&type=script&lang=ts"
import style0 from "./McmButton.vue?vue&type=style&index=0&id=95d557c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95d557c2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
